<!-- Trigger Element -->
<div #triggerRef class="inline-block" (mouseenter)="trigger === 'hover' ? show() : null"
    (mouseleave)="trigger === 'hover' ? hide() : null" (click)="trigger === 'click' ? toggle() : null"
    (focus)="trigger === 'focus' ? show() : null" (blur)="trigger === 'focus' ? hide() : null">
    <ng-content></ng-content>
</div>

<!-- Tooltip -->
@if (isVisible()) {
<div #tooltipRef [class]="computedTooltipClasses()" [style]="tooltipStyle()" role="tooltip"
    [attr.aria-hidden]="!isVisible()">
    <!-- Content -->
    <div class="relative z-10 whitespace-nowrap">
        {{ content }}
    </div>

    <!-- Glass shimmer effect -->
    <div
        class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-xl">
        <div class="absolute inset-0 bg-linear-to-r from-transparent via-white/20 to-transparent
                      transform -skew-x-12 -translate-x-full hover:translate-x-full
                      transition-transform duration-1000 ease-out"></div>
    </div>

    <!-- Premium floating particles -->
    @if (variant === 'primary') {
    <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-30 rounded-xl">
        <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/3 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500">
        </div>
    </div>
    }
</div>
}